<script setup lang="ts">
defineProps<{
  title?: string
  filters: Array<{
    name: string
    legend: string
    enabled: Set<string>
    options: ReadonlyArray<{ title: string, tagName: string, value: string }>
  }>
}>()
</script>

<template>
  <section class="relative flex flex-col gap-4 md:gap-12">
    <slot name="title">
      <h2
        v-if="title"
        class="text-center font-headline text-xl leading-[175%]! font-normal md:text-3xl"
        v-text="title"
      />
    </slot>

    <form class="space-y-6 md:grid md:grid-cols-1 md:grid-rows-2 md:gap-x-12">
      <!-- mobile -->
      <details
        v-for="{ legend, ...filter } in filters"
        :key="filter.name"
        class="mx-auto my-4 w-full border-b border-[var(--accent-color,var(--color-green-20))] pb-4 text-white md:hidden"
      >
        <summary class="relative flex w-full cursor-pointer list-none items-center justify-between text-[var(--filter-color,var(--color-seagreen-50))] max-sm:text-xs">
          {{ legend }}
        </summary>
        <UiFilterCheckbox
          v-bind="filter"
          size="lg"
          :ui="{
            fieldset: 'mt-5 mr-auto mb-8 ml-2',
          }"
        />
      </details>

      <!-- desktop -->
      <UiFilterCheckbox
        v-for="(filter, index) in filters"
        :key="filter.name"
        v-bind="filter"
        class="hidden md:block"
        :ui="{
          root: (index + 1 === filters.length)
            ? ['col-start-2 row-start-1 -row-end-1 border-(--accent-color) border-l pl-12']
            : ['col-start-1'],
          fieldset: (index + 1 === filters.length)
            ? ['grid grid-cols-3']
            : ['flex flex-row! flex-wrap'],
          legend: ['mb-6!'],
        }"
      />
    </form>

    <UiFilterReset />
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

details {
  summary {
    letter-spacing: 0.0625rem;

    &::-webkit-details-marker {
      @apply hidden;
    }

    &::after {
      @apply rounded-full size-6 mr-2 leading-none text-2xl grid place-content-center content-['+'] border-[var(--filter-color,var(--color-seagreen-50))] border-[1.5px];
    }
  }

  &[open] summary::after {
    @apply content-['-'];
  }
}
</style>
